import PropTypes from 'prop-types';
import { useEffect } from 'react';

import useMediaQuery from 'hooks/useMediaQuery';

import { sendEvent } from 'lib/gtag';
import { noop } from 'lib/utils';

const GA_EVENT_CATEGORY = 'dialog';

const Dialog = ({ drawer: Drawer, modal: Modal, onClose = noop, ...rest }) => {
  const { isLg } = useMediaQuery();

  useEffect(() => {
    const onOverlayClick = (event) => {
      if (event.target instanceof HTMLDialogElement) {
        onClose();
        sendEvent({
          action: 'click_outside_modal',
          category: GA_EVENT_CATEGORY,
        });
      }
    };

    document.addEventListener('click', onOverlayClick);

    return () => {
      document.removeEventListener('click', onOverlayClick);
    };
  }, []);

  if (isLg) {
    if (!Modal) {
      return null;
    }

    return <Modal onClose={onClose} {...rest} />;
  }

  return <Drawer onClose={onClose} {...rest} />;
};

Dialog.propTypes = {
  drawer: PropTypes.shape(),
  modal: PropTypes.shape(),
  onClose: PropTypes.func,
};

export default Dialog;
